import { Card } from '@/components/atoms';
import { CardContent } from '@/components/atoms/Card/Card';
import { Skeleton } from '@/components/atoms/Skeleton/Skeleton';
import { QUESTION_CARD_TEST_IDS } from '@/constants/data-testids';

export const QuestionCardSkeleton = () => {
  return (
    <Card data-testid={QUESTION_CARD_TEST_IDS.SKELETON} className="rounded-[12px] p-4">
      <CardContent>
        <Skeleton className="h-[14px] w-[400px] mb-3" />
        <div className="flex items-center gap-4 h-[22px]">
          <Skeleton className="h-[14px] w-[160px]" />
          <Skeleton className="h-[14px] w-[160px]" />
        </div>
      </CardContent>
    </Card>
  );
};
